/* Henley Spirit: "Buy 2 Get 1 Free" basket bar (2026-10-30, designed with Claude; white version).
   - Add to cart no longer opens the cart drawer. The drawer and the header basket count are still
     updated quietly, and this white bar rises from the bottom showing the item just added and how
     close the shopper is to a free item (the "Buy 2 Get 1 Free" automatic discount).
   - After 8 seconds (or on x) it shrinks to a small tag in the corner, so shoppers can keep browsing.
   - On page load it shows that small tag if the basket already has items in it.
   - While the basket has items, the Klaviyo "10% OFF" sign-up tab is hidden so the two don't stack.
   - The drawer still opens as normal from the header basket icon or "View basket", and anything
     added while the drawer is already open behaves as before.
   Works by wrapping cart-drawer's renderContents (assets/cart-drawer.js), which every Add to cart
   on the site calls (product cards via hs-card-add / hs-card-chain-picker, and the product form).
   Styles: assets/hs-basket-bar.css. Loaded from snippets/meta-tags.liquid.
   To switch it off without removing it: set window.hsBasketBarOff = true before this file loads. */
(function () {
  if (window.hsBasketBar) return;
  window.hsBasketBar = true;
  if (/^\/(cart|checkout)/.test(location.pathname)) return;

  var OFFER = /buy\s*2\s*get\s*1/i;
  var AUTO_COLLAPSE_MS = 8000;
  var root, panel, img, eyebrow, headline, steps, cta, pill, pillText, timer, paused = false, state = null;

  var GIFT = '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 10h18v4H3z M5 14h14v7H5z M12 10v11 M12 10c-2-4-6-4-6-1.5S10 10 12 10c2 0 6 1 6-1.5S14 6 12 10z" fill="none" stroke="#8A6A2F" stroke-width="1.5"/></svg>';
  var CROSS = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M2 2 L12 12 M12 2 L2 12" stroke="#777" stroke-width="1.5"/></svg>';

  function build() {
    root = document.createElement('div');
    root.className = 'hs-bb';
    root.hidden = true;
    root.innerHTML =
      '<div class="hs-bb__panel" role="status" aria-live="polite">' +
        '<div class="hs-bb__top">' +
          '<img class="hs-bb__img" alt="" width="42" height="42">' +
          '<div class="hs-bb__text"><p class="hs-bb__eyebrow"></p><p class="hs-bb__headline"></p></div>' +
          '<button type="button" class="hs-bb__x" aria-label="Hide">' + CROSS + '</button>' +
        '</div>' +
        '<div class="hs-bb__bottom">' +
          '<div class="hs-bb__steps">' +
            '<div class="hs-bb__step"><span class="hs-bb__seg"></span><span class="hs-bb__label">1st</span></div>' +
            '<div class="hs-bb__step"><span class="hs-bb__seg"></span><span class="hs-bb__label">2nd</span></div>' +
            '<div class="hs-bb__step is-free"><span class="hs-bb__seg"></span><span class="hs-bb__label">Free</span></div>' +
          '</div>' +
          '<a class="hs-bb__cta" href="/cart"></a>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="hs-bb__pill">' + GIFT + '<span></span></button>';
    document.body.appendChild(root);

    panel = root.querySelector('.hs-bb__panel');
    img = root.querySelector('.hs-bb__img');
    eyebrow = root.querySelector('.hs-bb__eyebrow');
    headline = root.querySelector('.hs-bb__headline');
    steps = root.querySelectorAll('.hs-bb__step');
    cta = root.querySelector('.hs-bb__cta');
    pill = root.querySelector('.hs-bb__pill');
    pillText = pill.querySelector('span');

    root.querySelector('.hs-bb__x').addEventListener('click', collapse);
    pill.addEventListener('click', function () { open(); });
    cta.addEventListener('click', function (e) {
      if (state && state.unlocked) return; // Checkout link
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        collapse();
        drawer.open();
      }
    });
    panel.addEventListener('pointerenter', function () { paused = true; clearTimeout(timer); });
    panel.addEventListener('pointerleave', function () { paused = false; arm(); });
    panel.addEventListener('focusin', function () { paused = true; clearTimeout(timer); });
    panel.addEventListener('focusout', function () { paused = false; arm(); });

    var queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; place(); });
    }, { passive: true });
  }

  // Sit above the product page's mobile sticky Add to cart bar when it is showing
  function place() {
    if (!root) return;
    var sticky = document.querySelector('.hs-sticky.is-visible');
    root.style.setProperty('--hs-bb-offset', sticky ? sticky.offsetHeight + 'px' : '0px');
  }

  function describe(cart) {
    var count = cart.item_count || 0;
    var unlocked = (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (a) {
        return OFFER.test((a.discount_application && a.discount_application.title) || '');
      });
    });
    var first = (cart.items || [])[0] || {};
    var s = { count: count, unlocked: unlocked, img: first.image || '', title: first.product_title || first.title || '' };
    if (unlocked) {
      s.eyebrow = 'Free item unlocked';
      s.headline = 'Your 3rd item is on us';
      s.pill = 'Free item unlocked';
      s.cta = 'Checkout';
      s.steps = 3;
    } else if (count === 1) {
      s.eyebrow = 'Added to basket';
      s.headline = 'Add 2 more, get 1 FREE';
      s.pill = '2 more = 1 free';
      s.cta = 'View basket';
      s.steps = 1;
    } else if (count === 2) {
      s.eyebrow = 'Added to basket';
      s.headline = 'Add 1 more and it\u2019s FREE';
      s.pill = '1 more = free';
      s.cta = 'View basket';
      s.steps = 2;
    } else {
      // 3+ items without the offer applied (e.g. items outside the offer): no promise, just confirm
      s.eyebrow = 'Added to basket';
      s.headline = s.title;
      s.pill = '';
      s.cta = 'View basket';
      s.steps = 0;
    }
    return s;
  }

  function paint(s) {
    state = s;
    // Once there is something in the basket, the 10% OFF sign-up tab gives way to this bar (CSS in hs-basket-bar.css)
    document.documentElement.classList.toggle('hs-bb-has-items', s.count > 0);
    if (s.img) {
      img.src = s.img + (s.img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      img.alt = s.title;
      img.hidden = false;
    } else {
      img.hidden = true;
    }
    eyebrow.textContent = s.eyebrow;
    headline.textContent = s.headline;
    root.classList.toggle('no-steps', s.steps === 0);
    root.classList.toggle('is-unlocked', s.unlocked);
    steps.forEach(function (step, i) {
      step.classList.toggle('is-filled', i < s.steps);
    });
    cta.textContent = s.cta;
    cta.setAttribute('href', s.unlocked ? '/checkout' : '/cart');
    cta.classList.toggle('is-solid', s.unlocked);
    pillText.textContent = s.pill;
  }

  function arm() {
    clearTimeout(timer);
    if (paused) return;
    timer = setTimeout(collapse, AUTO_COLLAPSE_MS);
  }

  function open() {
    if (!state || !state.count) return;
    place();
    root.hidden = false;
    root.classList.remove('is-pill');
    root.classList.add('is-open');
    arm();
  }

  function collapse() {
    clearTimeout(timer);
    root.classList.remove('is-open');
    if (state && state.pill) {
      root.classList.add('is-pill');
    } else {
      root.hidden = true;
    }
  }

  function showPill() {
    if (!state || !state.count || !state.pill) return;
    place();
    root.hidden = false;
    root.classList.remove('is-open');
    root.classList.add('is-pill');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function afterAdd() {
    fetchCart().then(function (cart) {
      if (!cart) return;
      paint(describe(cart));
      if (state.count) open(); else root.hidden = true;
    });
  }

  function patchDrawer() {
    var Drawer = customElements.get('cart-drawer');
    if (!Drawer || Drawer.prototype.hsBasketBarPatched) return;
    var original = Drawer.prototype.renderContents;
    Drawer.prototype.hsBasketBarPatched = true;
    Drawer.prototype.renderContents = function (parsedState) {
      if (window.hsBasketBarOff || this.classList.contains('active') || !parsedState || !parsedState.sections) {
        return original.call(this, parsedState);
      }
      try {
        var inner = this.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        this.productId = parsedState.id;
        var self = this;
        this.getSectionsToRender().forEach(function (section) {
          var el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          var html = parsedState.sections[section.id];
          if (el && html) el.innerHTML = self.getSectionInnerHTML(html, section.selector);
        });
        var overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));
      } catch (e) {
        return original.call(this, parsedState);
      }
      afterAdd();
    };
  }

  function start() {
    build();
    if (window.customElements) {
      if (customElements.get('cart-drawer')) patchDrawer();
      else customElements.whenDefined('cart-drawer').then(patchDrawer);
    }
    fetchCart().then(function (cart) {
      if (!cart || !cart.item_count) return;
      paint(describe(cart));
      showPill();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
